(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product-everelle"]) return;
  try {
    
document.querySelectorAll('[data-everelle-product]').forEach((page) => {
  if (page.dataset.initialized) return;
  page.dataset.initialized = 'true';
  const copy = JSON.parse(page.querySelector('[data-everelle-copy]').textContent);
  const choices = Array.from(page.querySelectorAll('[data-everelle-choice]'));
  const colourGroup = page.querySelector('[data-everelle-gold-colours]');
  const configure = (updateUrl = false) => {
    const choice = choices.find((input) => input.checked);
    const variant = copy.variants.find((item) => item.id === choice?.value);
    if (!variant) return;
    const silver = variant.silver;
    colourGroup.hidden = silver;
    colourGroup.disabled = silver;
    page.querySelector('[data-everelle-state]').textContent = copy.toOrderLabel;
    page.querySelector('[data-everelle-selected-material]').textContent = variant.title;
    page.querySelector('[data-everelle-price]').textContent = variant.price;
    page.querySelector('[data-everelle-gold-note]').hidden = silver;
    page.querySelector('[data-everelle-availability]').textContent = silver ? copy.silverAvailability : copy.goldAvailability;
    const add = page.querySelector('[data-everelle-add]');
    add.disabled = !variant.available;
    add.textContent = variant.available ? copy.addToBag : copy.unavailable;
    if (updateUrl) {
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);
    }
  };
  choices.forEach((choice) => choice.addEventListener('change', () => configure(true)));
  configure();
  const thumbnails = Array.from(page.querySelectorAll('[data-everelle-thumbnail]'));
  const panels = Array.from(page.querySelectorAll('[data-everelle-panel]'));
  thumbnails.forEach((thumbnail) => thumbnail.addEventListener('click', () => {
    const index = thumbnail.dataset.everelleThumbnail;
    panels.forEach((panel) => { const active=panel.dataset.everellePanel===index; panel.hidden=!active; panel.classList.toggle('is-active',active); });
    thumbnails.forEach((item) => { const active=item===thumbnail; item.classList.toggle('is-active',active); item.setAttribute('aria-pressed',String(active)); });
  }));
  const lightbox=page.querySelector('[data-everelle-lightbox]');
  if (lightbox) {
    const image=lightbox.querySelector('[data-everelle-lightbox-image]');
    const fullImageLink=lightbox.querySelector('[data-everelle-full-image]');
    const viewport=lightbox.querySelector('[data-everelle-viewport]');
    const canvas=lightbox.querySelector('[data-everelle-canvas]');
    const zoomIn=lightbox.querySelector('[data-everelle-zoom-in]');
    const zoomOut=lightbox.querySelector('[data-everelle-zoom-out]');
    const fit=lightbox.querySelector('[data-everelle-fit]');
    const zoomLevel=lightbox.querySelector('[data-everelle-zoom-level]');
    let zoom=1;
    let opener;
    let drag;
    const renderImage=(reset=false) => {
      if (!lightbox.open || !image.naturalWidth || !viewport.clientWidth) return;
      const centreX=(viewport.scrollLeft+viewport.clientWidth/2)/Math.max(canvas.offsetWidth,1);
      const centreY=(viewport.scrollTop+viewport.clientHeight/2)/Math.max(canvas.offsetHeight,1);
      const scale=Math.min(viewport.clientWidth/image.naturalWidth,viewport.clientHeight/image.naturalHeight,1)*zoom;
      const width=Math.round(image.naturalWidth*scale);
      const height=Math.round(image.naturalHeight*scale);
      image.style.width=`${width}px`; image.style.height=`${height}px`;
      canvas.style.width=`${Math.max(width,viewport.clientWidth)}px`;
      canvas.style.height=`${Math.max(height,viewport.clientHeight)}px`;
      viewport.scrollLeft=reset?0:centreX*canvas.offsetWidth-viewport.clientWidth/2;
      viewport.scrollTop=reset?0:centreY*canvas.offsetHeight-viewport.clientHeight/2;
      viewport.dataset.zoomed=String(zoom>1);
      zoomLevel.textContent=`${Math.round(zoom*100)}%`;
      zoomOut.disabled=zoom<=1; zoomIn.disabled=zoom>=4;
    };
    const setZoom=(value) => {zoom=Math.min(4,Math.max(1,value));renderImage(zoom===1);};
    zoomIn.addEventListener('click',()=>setZoom(zoom+.5));
    zoomOut.addEventListener('click',()=>setZoom(zoom-.5));
    fit.addEventListener('click',()=>setZoom(1));
    image.addEventListener('load',()=>renderImage(true));
    viewport.addEventListener('keydown',(event)=>{
      const moves={ArrowLeft:[-80,0],ArrowRight:[80,0],ArrowUp:[0,-80],ArrowDown:[0,80]};
      if (moves[event.key]) {event.preventDefault();viewport.scrollBy(...moves[event.key]);}
      else if (event.key==='Home') {event.preventDefault();viewport.scrollTo(0,0);}
      else if (event.key==='End') {event.preventDefault();viewport.scrollTo(viewport.scrollWidth,viewport.scrollHeight);}
      else if (event.key==='+' || event.key==='=') {event.preventDefault();setZoom(zoom+.5);}
      else if (event.key==='-') {event.preventDefault();setZoom(zoom-.5);}
      else if (event.key==='0') {event.preventDefault();setZoom(1);}
    });
    viewport.addEventListener('pointerdown',(event)=>{
      if (zoom<=1 || event.pointerType==='touch' || event.button!==0) return;
      drag={x:event.clientX,y:event.clientY,left:viewport.scrollLeft,top:viewport.scrollTop};
      viewport.setPointerCapture(event.pointerId);viewport.classList.add('is-dragging');viewport.focus();event.preventDefault();
    });
    viewport.addEventListener('pointermove',(event)=>{
      if (!drag) return;
      viewport.scrollLeft=drag.left+drag.x-event.clientX;viewport.scrollTop=drag.top+drag.y-event.clientY;
    });
    const endDrag=()=>{drag=null;viewport.classList.remove('is-dragging');};
    viewport.addEventListener('pointerup',endDrag);
    viewport.addEventListener('pointercancel',endDrag);
    viewport.addEventListener('lostpointercapture',endDrag);
    new ResizeObserver(()=>renderImage(zoom===1)).observe(viewport);
    page.querySelectorAll('[data-everelle-enlarge]').forEach((button) => button.addEventListener('click', () => {
      opener=button;zoom=1;
      image.src=button.dataset.image;image.alt=button.dataset.alt;fullImageLink.href=button.dataset.image;
      lightbox.showModal();renderImage(true);
    }));
    lightbox.querySelector('[data-everelle-close]').addEventListener('click',()=>lightbox.close());
    lightbox.addEventListener('click',(event)=>{if(event.target===lightbox)lightbox.close();});
    lightbox.addEventListener('close',()=>{endDrag();opener?.focus();});
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-tessa"]) return;
  try {
    
document.querySelectorAll('[data-tessa-product]').forEach((page) => {
  if (page.dataset.initialized) return;
  page.dataset.initialized = 'true';
  const copy = JSON.parse(page.querySelector('[data-tessa-copy]').textContent);
  const choices = Array.from(page.querySelectorAll('[data-tessa-choice]'));
  const colourGroup = page.querySelector('[data-tessa-gold-colours]');
  const colourChoices = Array.from(page.querySelectorAll('[data-tessa-colour]'));
  const updateColourLabel = () => {
    const selected = colourChoices.find((input) => input.checked);
    page.querySelector('[data-tessa-colour-label]').textContent = ` — ${selected.getAttribute('aria-label')}`;
  };
  const configure = (updateUrl = false) => {
    const choice = choices.find((input) => input.checked);
    const variant = copy.variants.find((item) => item.id === choice?.value);
    if (!variant) return;
    const silver = variant.sku === 'EJ-1252-V01';
    colourGroup.hidden = silver;
    colourGroup.disabled = silver;
    updateColourLabel();
    page.querySelector('[data-tessa-state]').textContent = silver ? copy.inProduction : copy.toOrder;
    page.querySelector('[data-tessa-price]').textContent = variant.price;
    page.querySelector('[data-tessa-gold-note]').hidden = silver;
    page.querySelector('[data-tessa-availability]').textContent = silver ? copy.silverAvailability : copy.goldAvailability;
    const add = page.querySelector('[data-tessa-add]');
    add.disabled = !variant.available;
    add.textContent = variant.available ? copy.addToBag : copy.unavailable;
    if (updateUrl) {
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);
    }
  };
  choices.forEach((choice) => choice.addEventListener('change', () => configure(true)));
  colourChoices.forEach((choice) => choice.addEventListener('change', updateColourLabel));
  configure();
  const thumbnails = Array.from(page.querySelectorAll('[data-tessa-thumbnail]'));
  const panels = Array.from(page.querySelectorAll('[data-tessa-panel]'));
  thumbnails.forEach((thumbnail) => thumbnail.addEventListener('click', () => {
    const index = thumbnail.dataset.tessaThumbnail;
    panels.forEach((panel) => { const active=panel.dataset.tessaPanel===index; panel.hidden=!active; panel.classList.toggle('is-active',active); });
    thumbnails.forEach((item) => { const active=item===thumbnail; item.classList.toggle('is-active',active); item.setAttribute('aria-pressed',String(active)); });
  }));
  const lightbox=page.querySelector('[data-tessa-lightbox]');
  if (lightbox) {
    const image=lightbox.querySelector('[data-tessa-lightbox-image]');
    const fullImageLink=lightbox.querySelector('[data-tessa-full-image]');
    const viewport=lightbox.querySelector('[data-tessa-viewport]');
    const canvas=lightbox.querySelector('[data-tessa-canvas]');
    const zoomIn=lightbox.querySelector('[data-tessa-zoom-in]');
    const zoomOut=lightbox.querySelector('[data-tessa-zoom-out]');
    const fit=lightbox.querySelector('[data-tessa-fit]');
    const zoomLevel=lightbox.querySelector('[data-tessa-zoom-level]');
    let zoom=1;
    let opener;
    let drag;
    const renderImage=(reset=false) => {
      if (!lightbox.open || !image.naturalWidth || !viewport.clientWidth) return;
      const centreX=(viewport.scrollLeft+viewport.clientWidth/2)/Math.max(canvas.offsetWidth,1);
      const centreY=(viewport.scrollTop+viewport.clientHeight/2)/Math.max(canvas.offsetHeight,1);
      const scale=Math.min(viewport.clientWidth/image.naturalWidth,viewport.clientHeight/image.naturalHeight,1)*zoom;
      const width=Math.round(image.naturalWidth*scale);
      const height=Math.round(image.naturalHeight*scale);
      image.style.width=`${width}px`; image.style.height=`${height}px`;
      canvas.style.width=`${Math.max(width,viewport.clientWidth)}px`;
      canvas.style.height=`${Math.max(height,viewport.clientHeight)}px`;
      viewport.scrollLeft=reset?0:centreX*canvas.offsetWidth-viewport.clientWidth/2;
      viewport.scrollTop=reset?0:centreY*canvas.offsetHeight-viewport.clientHeight/2;
      viewport.dataset.zoomed=String(zoom>1);
      zoomLevel.textContent=`${Math.round(zoom*100)}%`;
      zoomOut.disabled=zoom<=1; zoomIn.disabled=zoom>=4;
    };
    const setZoom=(value) => {zoom=Math.min(4,Math.max(1,value));renderImage(zoom===1);};
    zoomIn.addEventListener('click',()=>setZoom(zoom+.5));
    zoomOut.addEventListener('click',()=>setZoom(zoom-.5));
    fit.addEventListener('click',()=>setZoom(1));
    image.addEventListener('load',()=>renderImage(true));
    viewport.addEventListener('keydown',(event)=>{
      const moves={ArrowLeft:[-80,0],ArrowRight:[80,0],ArrowUp:[0,-80],ArrowDown:[0,80]};
      if (moves[event.key]) {event.preventDefault();viewport.scrollBy(...moves[event.key]);}
      else if (event.key==='Home') {event.preventDefault();viewport.scrollTo(0,0);}
      else if (event.key==='End') {event.preventDefault();viewport.scrollTo(viewport.scrollWidth,viewport.scrollHeight);}
      else if (event.key==='+' || event.key==='=') {event.preventDefault();setZoom(zoom+.5);}
      else if (event.key==='-') {event.preventDefault();setZoom(zoom-.5);}
      else if (event.key==='0') {event.preventDefault();setZoom(1);}
    });
    viewport.addEventListener('pointerdown',(event)=>{
      if (zoom<=1 || event.pointerType==='touch' || event.button!==0) return;
      drag={x:event.clientX,y:event.clientY,left:viewport.scrollLeft,top:viewport.scrollTop};
      viewport.setPointerCapture(event.pointerId);viewport.classList.add('is-dragging');viewport.focus();event.preventDefault();
    });
    viewport.addEventListener('pointermove',(event)=>{
      if (!drag) return;
      viewport.scrollLeft=drag.left+drag.x-event.clientX;viewport.scrollTop=drag.top+drag.y-event.clientY;
    });
    const endDrag=()=>{drag=null;viewport.classList.remove('is-dragging');};
    viewport.addEventListener('pointerup',endDrag);
    viewport.addEventListener('pointercancel',endDrag);
    viewport.addEventListener('lostpointercapture',endDrag);
    new ResizeObserver(()=>renderImage(zoom===1)).observe(viewport);
    page.querySelectorAll('[data-tessa-enlarge]').forEach((button) => button.addEventListener('click', () => {
      opener=button;zoom=1;
      image.src=button.dataset.image;image.alt=button.dataset.alt;fullImageLink.href=button.dataset.image;
      lightbox.showModal();renderImage(true);
    }));
    lightbox.querySelector('[data-tessa-close]').addEventListener('click',()=>lightbox.close());
    lightbox.addEventListener('click',(event)=>{if(event.target===lightbox)lightbox.close();});
    lightbox.addEventListener('close',()=>{endDrag();opener?.focus();});
  }
});

  } catch(e) { console.error(e); }
})();
})();
